import useEmbedEvents, { useSendEvent } from '../../hooks/useEmbedEvents';
import { PAGE_MAX } from '../../components/designsystem/Pagination';
import SearchList from '../../components/SearchList';
import SearchMap from '../../components/SearchMap';
import Search from '../../components/Search';
import searchParams from '../../constants/searchParams';
import { parse } from 'query-string';
import { decodeQueryParams, StringParam, useQueryParams } from 'use-query-params';
import removeUndefinedEntries from '../../utils/removeUndefinedEntries';
import { AllowedSearchAction } from '../../components/SearchResults';
import { useRouter } from 'next/router';
import { GlobalStyle } from '../../components/embed/GlobalStyle';
import styled from 'styled-components';
import getLastMinuteOptions from '../../utils/getLastMinuteOptions';

const SearchEmbed = () => {
    const { triggerSearchCallback } = useEmbedEvents();
    const { query } = useRouter();
    const [, setQueryParams] = useQueryParams({
        viewType: StringParam,
    });
    const sendEvent = useSendEvent();

    if (!query) {
        return null;
    }

    const lastMinuteOptions = query?.enableLastMinute === 'true' ? getLastMinuteOptions().startParams : {};
    const params = query?.searchParams
        ? removeUndefinedEntries(
              decodeQueryParams(
                  searchParams,
                  parse(Array.isArray(query.searchParams) ? query.searchParams.join('&') : query.searchParams)
              )
          )
        : null;

    return (
        <Container>
            {query && (
                <Search
                    amountPerPage={query?.viewType === 'map' ? 25 : PAGE_MAX}
                    startParams={{ ...lastMinuteOptions, ...{ accommodationType: 'all', ...params } }}
                    ResultsComponent={query?.viewType === 'map' ? SearchMap : SearchList}
                    contentWrapperVariant="embed"
                    buttonTypes={
                        [
                            query?.enableFilters && 'filters',
                            query?.enableViewType && query?.viewType === 'map' && 'list',
                            query?.enableViewType && query?.viewType !== 'map' && 'map',
                            query?.enableSort && JSON.parse(query.enableSort as string) && 'sort',
                        ].filter(Boolean) as AllowedSearchAction[]
                    }
                    enableFilters={query?.enableFilters ? JSON.parse(query.enableFilters as string) : true}
                    enableSearch={query?.enableSearch ? JSON.parse(query.enableSearch as string) : true}
                    onMapClick={() => {
                        setQueryParams({ viewType: 'map' });
                        sendEvent({ type: 'changeViewType', viewType: 'map', source: 'travelbase' });
                    }}
                    onListClick={() => {
                        setQueryParams({ viewType: 'list' });
                        sendEvent({ type: 'changeViewType', viewType: 'list', source: 'travelbase' });
                    }}
                    ignoreStorage
                    onHitClick={(unit, _searchParams) => {
                        triggerSearchCallback('onHitClick', unit, _searchParams);
                    }}
                />
            )}
            <GlobalStyle />
        </Container>
    );
};
export default SearchEmbed;

const Container = styled.div`
    * {
        --page-margin: 0px;
    }

    padding-left: 2px;
`;
